export default [
  {
    path: '/blog',
    name: 'blog',
    component: () => import('@/views/menu/blog/blog.vue'),
    meta: {
      pageTitle: 'مدیریت مقاله ها',
      action: 'show',
      resource: 'BlogManager',
    },
  },
  {
    path: '/blog/details/:id?',
    name: 'blogdetails',
    component: () => import('@/views/menu/blog/blogdetails.vue'),
    meta: {
      pageTitle: 'جزئیات مقاله',
      action: 'show',
      resource: 'BlogManager',
    },
  },
  {
    path: '/blogcategory',
    name: 'blogcategory',
    component: () => import('@/views/menu/blog/blogcategory.vue'),
    meta: {
      pageTitle: 'مدیریت دسته بندی های مقاله',
      action: 'show',
      resource: 'BlogCategoryManager',
    },
  },
  {
    path: '/blogcategory/details/:id',
    name: 'blogcategorydetails',
    component: () => import('@/views/menu/blog/blogcategorydetails.vue'),
    meta: {
      pageTitle: 'جزئیات دسته بندی مقاله',
      action: 'show',
      resource: 'BlogCategoryManager',
    },
  },
]
